import {
  Dropdown,
  Field as Field2,
  Item,
  Menu,
  Select
} from "@zendeskgarden/react-dropdowns";
import { Field, Input, Label, Message } from "@zendeskgarden/react-forms";
import { Dots } from "@zendeskgarden/react-loaders";
// @ts-ignore
import ReactFilestack from "filestack-react";
import React from "react";
import GooglePlacesAutocomplete, {
  geocodeByPlaceId
} from "react-google-places-autocomplete";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { AnyAction, bindActionCreators, Dispatch } from "redux";
import { currentLanguageChanged } from "../../actions";
import HeaderMobile from "../../components/header";
import { UserData } from "../../model/user.model";
import {
  SIGNUP_ROUTE,
  SIGNUP_SUCCESS_ROUTE,
  TERMS_OF_USE_ROUTE
} from "../../providers/routes";
import { AlertService } from "../../services/alert.service";
import { AuthenticationService } from "../../services/auth.service";
import TranslationService, { t } from "../../translations/translation.service";
import "./index.css";
// import { Modal, ModalBody, ModalFooter, ModalTitle } from "react-bootstrap";
import UserService from "../../services/user.service";
import FileStackService from "../../services/filestack.service";

const { REACT_APP_FILESTACK_API } = process.env;
const { zdColorSecondaryOrange400 } = require("@zendeskgarden/css-variables");
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);

class SignupLocation extends React.Component<any> {
  state = {
    currentLang: TranslationService.getCurrentLanguage,
    user: {
      email: "",
      password: "",
      firstName: "",
      lastName: "",
      pcd: false,
      geolocation: null,
      address: null,
      contato: "",
      fileName: "",
      files: [],
      vagaId: undefined,
      dadosPessoais: {} as any,
      policyAndSignature: '' as string,
      europeanUnionCitizenship: false
    },
    width: window.innerWidth,
    locationValid: true,
    contatoValid: true,
    formValid: false,
    loadingSubmit: false,
    isModalVisible: false,
    policyString: '' as string,
    signatureString: '' as string,
  };

  constructor(props: any) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.includeLocation = this.includeLocation.bind(this);
    this.policeAndSignatureString = this.policeAndSignatureString.bind(this);
  }

  componenDidUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }

  async policeAndSignatureString(): Promise<void> {
    try {
      const policyAndSignature = await FileStackService.getPoliceAndSignature();
      this.setState({
        policyString: policyAndSignature.data.policy,
        signatureString: policyAndSignature.data.signature
      });
    } catch(err: any) {
      console.log("ERROR: ", err);
    }
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  redirectToHome() {
    this.props.history.push("/");
  }

  async componentDidMount() {
    window.addEventListener("resize", this.handleWindowSizeChange);
    const { currentLanguageChanged } = this.props;
    const user = this.props.location.data;
    await this.policeAndSignatureString();
    if (!user) {
      this.props.history.push(SIGNUP_ROUTE);
    } else {
      const { firstName, lastName, email, password, dadosPessoais, vagaId, europeanUnionCitizenship } = user;
      this.setState({
        user: {
          ...this.state.user,
          firstName,
          lastName,
          email,
          password,
          dadosPessoais,
          vagaId,
          europeanUnionCitizenship
        },
      });
      currentLanguageChanged(this.state.currentLang);
    }
  }

  componentDidUpdate(prevProps: Readonly<any>, _prevState: Readonly<{}>): void {
    if (
        this.state.width <= 680 &&
        prevProps.currentLanguage !== this.props.currentLanguage
        && typeof(this.props.currentLanguage) !== "function"
      ) {
      this.setState({ currentLang: this.props.currentLanguage});
    }
  }

  async handleSetPrivacyPolicy(userId: string) {
    const sixMonthsInMilliseconds = 15724800000;
    const dateOfAcceptance = new Date(Date.now());
    const expirationDate = new Date(Date.now() + sixMonthsInMilliseconds);

    const data = {consent: true, dateOfAcceptance, expirationDate};

    await UserService.setPrivacyPolicySignupLocation(userId, data);
  }

  handleSubmit = (event: any) => {
    this.setState({ loadingSubmit: true });
    event.preventDefault();
    const userData: Partial<UserData> = {
      email: this.state.user.email,
      firstName: this.state.user.firstName,
      lastName: this.state.user.lastName,
      password: this.state.user.password,
      attachments: this.state.user.files,
      dadosPessoais: {
        pcdUser: {
          isUserPCD: this.state.user.dadosPessoais.pcdUser.isUserPCD,
          defs: [],
        },
        localidade: undefined,
        geolocation: this.state.user.geolocation,
        indicadoPor: undefined,
      },
      contato: {
        lista: [
          {
            tipo: "Preferencial",
            contato: this.state.user.contato,
            locale: TranslationService.getCurrentLanguage(),
          },
        ],
      },
      vagaId: this.state.user.vagaId,
      europeanUnionCitizenship: this.state.user.europeanUnionCitizenship,
      policyAndSignature: this.state.user.policyAndSignature
    };
    AuthenticationService.signup(userData, TranslationService.getCurrentLanguage())
      .then((data: any) => {
        if (data.message === "PROFESSIONAL_REGISTERED_WITH_SUCCESS") {
          this.props.history.push({
            pathname: SIGNUP_SUCCESS_ROUTE,
            data: userData.email,
          });
          this.handleSetPrivacyPolicy(data.user.id);
        } else {
          AlertService.error(
            t("Sistema indisponível, por favor tente novamente mais tarde.")
          );
        }
      })
      .catch((error: any) => {
        if (error.response.data) {
          switch (error.response.data.message) {
            case "EMAIL_ALREADY_REGISTERED":
              global.alert("Email já cadastrado");
              break;
          }
        }
      })
      .finally(() => {
        this.setState({ loadingSubmit: false });
      });
  }

  handleInputChange(event: any) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState(
      {
        user: {
          ...this.state.user,
          [name]: value,
        },
      },
      () => {
        this.validateField(name, value);
      }
    );
  }

  validateField(fieldName: string, value: any) {
    let locationValid = this.state.locationValid;
    let contatoValid = this.state.contatoValid;

    switch (fieldName) {
      case "geolocation":
        locationValid = value !== undefined && value !== null;
        break;
      case "contato":
        contatoValid = value.length >= 8;
        break;
      default:
        break;
    }
    this.setState(
      {
        locationValid,
        contatoValid,
      },
      this.validateForm
    );
  }

  validateForm() {
    this.setState({
      formValid: !!(
        this.state.contatoValid &&
        this.state.user.contato &&
        this.state.locationValid &&
        this.state.user.geolocation &&
        this.state.user.files.length > 0
      ),
    });
  }

  onFiles = async ({ filesUploaded }: any) => {
    var array = filesUploaded.map(function (item: any) {
      return {
        fileName: item.filename,
        url: item.url,
      };
    });
    const policyAndSignature = (await FileStackService.getFileStackSecreteCodeToUserSignup(
      array[0].url, false
    )).data;
    this.setState({
      user: { ...this.state.user, fileName: array[0].fileName, files: array, policyAndSignature },
    }, () => this.validateForm());

  };

  includeLocation(data: any) {
    geocodeByPlaceId(data.value.place_id)
      .then((geocode) => {
        this.setState({
          user: {
            ...this.state.user,
            geolocation: geocode[0],
            address: data,
          },
        });
      })
      .catch((error) => console.error(error));
  }

  render() {
    const { width } = this.state;
    const isMobile = width <= 680;
    const { currentLanguageChanged } = this.props;
    const langs = TranslationService.getLanguages();

    if (!isMobile) {
      return (
        <div className="bg-enter">
          <div className="d-flex align-items-center justify-items-center h-100">
            <div className="bg-container">
              <div className="content-signup d-flex justify-content-between justify-items-center flex-column">
                <div>
                  <div className="row">
                    <div className="col">
                      <p
                        className="enter-logo"
                        style={{ cursor: "pointer" }}
                        onClick={this.redirectToHome.bind(this)}
                      />
                    </div>
                    <div className="d-flex align-items-center mr-1">
                      <Dropdown
                        selectedItem={TranslationService.getCurrentLanguage()}
                        onSelect={(selectedLang) => {
                          TranslationService.changeLanguage(selectedLang);
                          this.setState({ currentLang: selectedLang });
                          currentLanguageChanged(selectedLang);
                        }}
                        downshiftProps={{
                          itemToString: (item: any) => item,
                        }}
                      >
                        <Field2>
                          <Select className="u-semibold u-fs-sm border-0">
                            {t(TranslationService.getCurrentLanguage())}
                          </Select>
                        </Field2>
                        <Menu className="u-fs-sm">
                          {langs.map((option: any) => (
                            <Item key={option} value={option}>
                              {t(option)}
                            </Item>
                          ))}
                        </Menu>
                      </Dropdown>
                    </div>
                  </div>

                  <form className="login-body" onSubmit={this.handleSubmit}>
                    <h1 className="signup-title mb-4">{t("Cadastre-se")}</h1>
                    <Field className="mt-2">
                      <Label style={{ width: "100%"}}>
                        <GooglePlacesAutocomplete
                          apiKey="AIzaSyC5_B8f8Ug5dmvdYe3QWv6N2YoKszO0gK4"
                          minLengthAutocomplete={3}
                          selectProps={{
                            value: this.state.user.address,
                            onChange: this.includeLocation,
                            placeholder: "Local de residência",
                            noOptionsMessage: () => t("Digite as 3 primeiras letras da sua cidade"),
                            styles: {
                              singleValue: (provided: any) => ({
                                ...provided,
                                fontSize: "14px",
                              }),
                            },
                          }}
                        />
                      </Label>
                      {!this.state.locationValid && (
                        <Message validation="error">
                          {t("Local inválido.")}
                        </Message>
                      )}
                    </Field>
                    <Field className="mt-2">
                      <Input
                        disabled={this.state.loadingSubmit}
                        validation={
                          this.state.contatoValid ? undefined : "error"
                        }
                        onBlur={this.handleInputChange}
                        name="contato"
                        placeholder={t("Telefone principal")}
                      ></Input>
                      {!this.state.contatoValid && (
                        <Message validation="error">
                          {t("Telefone inválido.")}
                        </Message>
                      )}
                    </Field>

                    <Field>
                      <Label className="mt-4">{t("Upload do Currículo")}</Label>
                      {this.state.policyString.length > 0 && (
                        <ReactFilestack
                          apikey={REACT_APP_FILESTACK_API}
                          componentDisplayMode={{
                            type: "button",
                            customText: t("Arquivos PDF ou DOCX de até 5MB"),
                            customClass: "c-txt__input",
                          }}
                          actionOptions={{
                            accept: [".pdf", ".docx"],
                          }}
                          clientOptions={{
                            security: {
                              policy: this.state.policyString,
                              signature: this.state.signatureString,
                            }
                          }}
                          onSuccess={this.onFiles}
                        />
                      )}
                      <small className="c-txt__message c-txt__message--success">
                        {this.state.user.fileName}
                      </small>
                    </Field>
                    <button
                              type="submit"
                              className="btn-enviar w-100 mt-2 button-entrar"
                              onClick={(event) => this.handleSubmit(event)}
                            >
                            {!this.state.loadingSubmit && t("Cadastrar")}
                            {this.state.loadingSubmit && (
                              <Dots
                                key="dots-loading"
                                color={zdColorSecondaryOrange400}
                                size="32px"
                              />
                            )}
                            </button>
                            <p className="text-center u-fs-md u-fg-grey-500 mt-2 mx-2">
                              {t("Ao clicar em Aceitar e cadastrar, você aceita os ")}
                              <a
                                href={TERMS_OF_USE_ROUTE}
                                className="u-semibold u-fg-grey-500"
                              >
                                {t("Termos de Uso do Enter.")}
                              </a>
                            </p>
                    {/* <button
                      type="button"
                      onClick={() => this.setState({isModalVisible: true})}
                      disabled={
                        !this.state.formValid || this.state.loadingSubmit
                      }
                      className="btn-enviar w-100 mt-5 button-entrar"
                    >
                      Continuar
                    </button> */}
                    {/* {this.state.isModalVisible 
                    && (
                      <Modal 
                      show={this.state.isModalVisible}
                      scrollable
                      size="lg"
                      aria-labelledby="contained-modal-title-vcenter"
                      centered
                      >
                        <ModalTitle
                        className="mt-4 w-100 text-center"
                        >
                          Política de Tratamento de Dados</ModalTitle>
                        <ModalBody>
                          <div
                            className="mt-2 ml-2 mr-2 text-justify"
                          >
                            <ul>
                              <li>
                              <h5>POLÍTICA DE PRIVACIDADE</h5>
                              <p>A <strong>Elumini S.A. (Elumini)</strong> valoriza a privacidade de seus usuários e criou esta Política de Privacidade para demonstrar seu compromisso em proteger a sua privacidade e seus dados pessoais, nos termos da Lei Geral de Proteção de Dados e demais leis sobre o tema, bem como descrever de que forma sua privacidade é protegida pela <strong>Elumini</strong> ao coletar, tratar e armazenar suas informações pessoais.</p>
                              </li>

                              <li>
                              <h5>DEFINIÇÕES</h5>
                              <p><strong>Usuário:</strong> todas as pessoas físicas que utilizarão ou visitarão o(s) Site(s) e/ou Aplicativo(s), maiores de 18 (dezoito) anos ou emancipadas e totalmente capazes de praticar os atos da vida civil ou os absolutamente ou relativamente incapazes devidamente representados ou assistidos.<br/><br/> <strong>Dados Pessoais:</strong> significa quaisquer informações fornecidas e/ou coletadas pela <strong>Elumini</strong>, por qualquer meio, ainda que públicos, que: (I) identifiquem, ou que, quando usadas em combinação com outras informações tratadas pela <strong>Elumini</strong> identifiquem um indivíduo; ou (II) por meio das quais a identificação ou informações de contato de uma pessoa física possam ser derivadas.<br/><br/> <strong>Finalidade:</strong> o objetivo, o propósito que a <strong>Elumini</strong> deseja alcançar a partir de cada ato de tratamento das informações pessoais.<br/><br/> <strong>Necessidade:</strong> justificativa pelo qual é estritamente necessário coletar dados pessoais, para atingir a finalidade, evitando-se a coleta excessiva.<br/><br/> <strong>Bases legais:</strong> fundamentação legal que torna legítimo o tratamento de dados pessoais para uma determinada finalidade prévia por parte da <strong>Elumini</strong>.<br/><br/> <strong>Consentimento:</strong> autorização expressa e inequívoca dada pelo Usuário titular do dado pessoal para que a <strong>Elumini</strong> trate seus dados pessoais para uma finalidade previamente descrita, na qual a base legal necessária para o ato demande a autorização expressa do titular.<br/><br/> Esta política se aplica, em geral, a todos os Usuários e potenciais Usuários dos serviços oferecidos pela <strong>Elumini</strong>, incluindo Usuários dos sites ou outros meios operados pela <strong>Elumini</strong> e resume como a <strong>Elumini</strong>, como controladora dos seus Dados Pessoais, poderá tratá-los, de acordo com as bases legais aplicáveis e todas as leis de privacidade e proteção de dados em vigor.<br/><br/> Ao acessar e/ou utilizar o site da <strong>Elumini</strong>, o Usuário declara ter no mínimo 18 (dezoito) anos e ter capacidade plena e expressa para a aceitação dos termos e condições desta Política de Privacidade e do Termo de Consentimento para todos os fins de direito.<br/><br/> Caso o Usuário não se enquadre na descrição acima e/ou não concorde, ainda que em parte, com os termos e condições contidos nesta Política de Privacidade, não deverá acessar e/ou utilizar os serviços oferecidos pela <strong>Elumini</strong>, bem como os sites e serviços por ela operados.<br/><br/> </p>
                              </li>

                              <li>
                              <h5>COLETA E USOS DE INFORMAÇŌES PESSOAIS</h5>
                              <p>O Usuário está ciente de que fornece informação de forma consciente e voluntária por meio de formulários ou por meio dos sites operados pela <strong>Elumini</strong>.<br/><br/> Quando o Usuário realiza o cadastro e/ou preenche formulários oferecidos pela <strong>Elumini</strong>, determinados Dados Pessoais solicitados serão mantidos em sigilo e serão utilizadas apenas para o propósito que motivou o cadastro, conforme a seguinte tabela:</p><table className="table table-sm text"><tbody><tr><th>MOMENTO</th><th>CATEGORIA DE DADOS PESSOAIS</th><th>FINALIDADE</th><th>BASE LEGAL</th></tr><tr><td className="mr-1">Início</td><td className="mr-1">E-mail*</td><td className="mr-1">Para poder acessar conteúdos e receber dicas de contratação (Newsletter). Bem como, para manter um canal de comunicação com o usuário e organização de suas informações na busca por uma oferta de contratação.</td><td className="mr-1">Consentimento</td></tr><tr><td className="mr-1">Contato/Cadastro Inicial do Perfil</td><td className="mr-1">Nome; Local de disponibilidade de trabalho*; Telefone*; Link de Portfólio e Redes Sociais (LinkedIn, GitHub, Stack Overflow e Site Pessoal, portifólio)</td><td className="mr-1">Para que possamos ter informações mínimas e necessárias sobre você para adequar apropriadamente o seu currículo para encaminhá-lo para as empresas em potencial e garantir a congruência do seu perfil na plataforma.</td><td className="mr-1">Consentimento</td></tr><tr><td className="mr-1">Contato/Cadastro Inicial do Perfil</td><td className="mr-1">Informação se usuário é PcD (Pessoa com Deficiência) e seu sexo.</td><td className="mr-1">Para que potenciais empresas empregadoras encaixem requisitos de vagas às suas quotas, os termos da CLT (Consolidação das Leis do Trabalho - Decreto-Lei n. 5.452/43) e da Lei n. 8.231/91.</td><td className="mr-1">Consentimento</td></tr><tr><td className="mr-1">Contato/Cadastro Inicial do Perfil</td><td className="mr-1">Foto de Perfil</td><td className="mr-1">Para melhor ranqueamento do seu currículo no processo de seleção e recrutamento para as empresas em potencial.</td><td className="mr-1">Consentimento</td></tr><tr><td className="mr-1">Área de Atuação, Experiências e Educação</td><td className="mr-1">Último e/ou Atual Salário*; Pretensão Salarial; Cargo; Onde trabalha e/ou trabalhou; Nível de Educação; Certificados; Tecnologias que conhece; Linguagens de conhecimento.</td><td className="mr-1">Para montagem do seu currículo e, consequentemente, para melhor ranqueamento do seu currículo no processo de seleção e recrutamento para as empresas em potencial.</td><td className="mr-1">Consentimento</td></tr><tr><td className="mr-1">Informações de Acesso</td><td className="mr-1">Endereço de IP, Cookies....</td><td className="mr-1">Para otimização das funcionalidades do nosso site, bem como da busca de vagas ao usuário de acordo com a região em que se encontra.</td><td className="mr-1">Legítimo interesse</td></tr></tbody></table><p></p>
                              </li>

                              <li>
                              <h5>COMPARTILHAMENTO E TRATAMENTO DE INFORMAÇŌES PESSOAIS</h5>
                              <p>A <strong>Elumini</strong> poderá divulgar os Dados Pessoais coletados a terceiros, nas seguintes situações e nos limites exigidos e autorizados pela Lei:<br/> </p><ol> <li>Com os seus clientes e parceiros quando necessário e/ou apropriado à prestação de serviços relacionados, sobretudo os relacionados ao recrutamento e seleção;</li> <li>Com as empresas e indivíduos contratados para a execução de determinadas atividades e serviços em nome da <strong>Elumini</strong>;</li> <li>Com empresas do grupo;</li> <li>Com fornecedores e parceiros para consecução dos serviços contratados com a <strong>Elumini</strong> (como tecnologia da informação, contabilidade, entre outros);</li> <li>Para propósitos administrativos como: pesquisa, planejamento, desenvolvimento de serviços, segurança e gerenciamento de risco.</li> <li>Quando necessário em decorrência de obrigação legal, determinação de autoridade competente, ou decisão judicial.</li> </ol> <br/> <p> Atualmente, para melhor execução dos serviços da <strong>Elumini</strong>, os seus Dados Pessoais são compartilhados com as seguintes operadoras: </p> <table className="table table-sm"><tbody><tr><th>Operador</th><th>Finalidade</th><th>Consulte a Política de Privacidade</th></tr><tr><td className="mr-1">Google Analytics</td><td className="mr-1">Ferramenta de monitoramento utilizada para entendermos melhor quem tem nos visitado e, assim, melhorar nossos serviços.</td><td className="mr-1">https://support.google.com/analytics/answer/4597324?hl=pt-BR</td></tr><tr><td className="mr-1">Filestack</td><td className="mr-1">Ferramenta de upload de documentos</td><td className="mr-1">https://www.ideracorp.com/Legal/PrivacyShield</td></tr></tbody></table> <br/> <p> Nas hipóteses de compartilhamento de Dados Pessoais com terceiros, todos os sujeitos mencionados nos itens I a VI deverão utilizar os Dados Pessoais partilhados de maneira consistente e de acordo com os propósitos para os quais foram coletados (ou com os quais o Usuário consentiu previamente) e de acordo com o que foi determinado por esta Política de Privacidade, outras declarações de privacidade de website ou países, e todas as leis de privacidade e proteção de dados aplicáveis.<br/><br/> Quando a empresa recrutadora, cliente da <strong>Elumini</strong>, for uma instituição financeira ou uma seguradora, de acordo normas legais e regulamentações do Banco Central do Brasil e da Susep - Superintendência de Seguros Privados, seus dados poderão ser consultados para uma possível análise relacionada à práticas ilícitas tais como lavagem de dinheiro e terrorismo (Circular nº 3978 do BACEN e Circular nº 612/2020 da SUSEP). </p> <p></p>
                              </li>

                              <li>
                              <h5>MOTIVOS LEGAIS PARA A DIVULGAÇÃO DE SEUS DADOS</h5>
                              <p>Em certas circunstâncias, a <strong>Elumini</strong> poderá divulgar Dados Pessoais, na medida necessária ou apropriada, para órgãos governamentais, consultores e outros terceiros com o objetivo de cumprir com a legislação aplicável ou com uma ordem ou intimação judicial ou, ainda, se a <strong>Elumini</strong> acreditar de boa-fé que tal ação seja necessária para:<br/> </p><ol> <li>Cumprir com uma legislação que exija tal divulgação;</li> <li>Investigar, impedir ou tomar medidas relacionadas a atividades ilegais suspeitas ou reais ou para cooperar com órgãos públicos ou para proteger a segurança nacional;</li> <li>Execução de seus contratos;</li> <li>Investigar e se defender contra quaisquer reivindicações ou alegações de terceiros;</li> <li>Proteger a segurança ou a integridade dos serviços (por exemplo, o compartilhamento com empresas que estão sofrendo ameaças semelhantes);</li> <li>Exercer ou proteger os direitos, a propriedade e a segurança da <strong>Elumini</strong> e suas empresas coligadas;</li> <li>Proteger os direitos e a segurança pessoal de seus funcionários, usuários ou do público;</li> <li>Em caso de venda, compra, fusão, reorganização, liquidação ou dissolução da <strong>Elumini</strong>.</li> </ol> <br/> <p>A <strong>Elumini</strong> poderá contestar essas demandas se julgar que as solicitações são excessivas, vagas ou feitas por autoridades incompetentes.</p> <p></p>
                              </li>

                              <li>
                              <h5>SEGURANÇA DE INFORMAÇŌES PESSOAIS</h5>
                              <p>Todos os Dados Pessoais serão guardados na base de dados da <strong>Elumini</strong> ou em base de dados mantidas “na nuvem” pelos fornecedores de serviços contratados pela <strong>Elumini</strong>, os quais estão devidamente de acordo com a legislação de proteção de dados vigente.<br/><br/> A <strong>Elumini</strong> e seus fornecedores utilizam diversos procedimentos de segurança para proteger a confidencialidade, segurança e integridade de seus Dados Pessoais, prevenindo a ocorrência de eventuais danos em virtude do tratamento desses dados.<br/><br/> Embora a <strong>Elumini</strong> utilize medidas de segurança e monitore seu sistema para verificar vulnerabilidades e ataques para proteger seus Dados Pessoais contra divulgação não autorizada, mau uso ou alteração, o Usuário entende e concorda que não há garantias de que as informações não poderão ser acessadas, divulgadas, alteradas ou destruídas por violação de qualquer uma das proteções físicas, técnicas ou administrativas. </p>
                              </li>

                              <li>
                              <h5>RETENÇÃO DE DADOS</h5>
                              <p>A <strong>Elumini</strong> retém todos os dados fornecidos, inclusive os Dados Pessoais, enquanto o cadastro do Usuário estiver ativo e conforme seja necessário para consecução de seus serviços.<br/><br/> A <strong>Elumini</strong> reterá seus Dados Pessoais e manterá seus dados armazenados até eventual requerimento de exclusão, ou de acordo com os períodos descritos neste documento.<br/><br/> A <strong>Elumini</strong> poderá vir a manter seus Dados Pessoais após receber seu pedido de exclusão ou após os prazos deste documento caso seja necessário para cumprimento de obrigações legais, resolver disputas, manter a segurança, evitar fraudes e abuso e garantir o cumprimento de contratos.<br/><br/> É importante ressaltar que, nos casos de contratação, a empresa que recrutou o candidato esta assumirá o papel de <strong>controladora</strong> dos dados pessoais e, dessa forma, manterá os dados armazenados pelo período que julgar necessário, de acordo com seus próprios critérios internos e legais.<br/><br/> Dessa forma, como se trata de uma outra relação de tratamento, a <strong>Elumini</strong> não possui gestão sobre tal questão. </p>
                              </li>

                              <li>
                              <h5>BASES LEGAIS PARA PROCESSAMENTO</h5>
                              <p>A <strong>Elumini</strong> apenas trata Dados Pessoais em situações em que está autorizada legalmente ou mediante seu expresso e inequívoco consentimento do Usuário.
                              <br/><br/> Conforme descrito na presente Política, a <strong>Elumini</strong> tem bases legais para coletar, produzir, receptar, classificar, utilizar, acessar, reproduzir, transmitir, distribuir, processar, arquivar, armazenar, eliminar, avaliar ou controlar a informação, modificar, comunicar, transferir, difundir ou extrair dados sobre o Usuário.<br/><br/> As bases legais incluem seu consentimento (colhido de forma expressa e inequívoca em nossa Plataforma), contratos e procedimentos preliminares contratuais (em que o processamento é necessário para firmar o contrato com o Usuário) e interesses legítimos, desde que tal processamento não viole seus direitos e liberdades, conforme se pode verificar neste documento.<br/><br/> Tais interesses incluem proteger o Usuário e a <strong>Elumini</strong> de ameaças, cumprir a legislação aplicável, o exercício regular de direitos em processo judicial, administrativo ou arbitral, habilitar a realização ou administração dos negócios, incluindo controle de qualidade, relatórios e serviços oferecidos, gerenciar transações empresariais, entender e melhorar os negócios e relacionamentos com os clientes e permitir que os usuários encontrem oportunidades econômicas.<br/><br/> O Usuário tem o direito de negar ou retirar o consentimento fornecido à <strong>Elumini</strong>, quando esta for a base legal para tratamento dos dados pessoais, podendo a <strong>Elumini</strong> encerrar a consecução de seus serviços para este usuário na hipótese de ocorrência de tal solicitação, observando-se, contudo, que, em eventuais casos, os clientes da <strong>Elumini</strong>, por conta da contratação, ou de procedimentos preliminares à contratação, assumirão o papel de controlador dos dados pessoais, devendo o titular, neste caso, requisitar diretamente a este a exclusão dos dados.<br/><br/> Caso tenha dúvidas sobre as bases legais para coleta, tratamento e armazenamento de seus dados pessoais, entre em contato com a <strong>Elumini</strong> e seu <i>Data Protection Officer</i> por meio do e-mail <u>dpo@elumini.com.br</u>. </p>
                              </li>

                              <li>
                              <h5>DIREITO DE ACESSAR E CONTROLAR SEUS DADOS PESSOAIS</h5>
                              <p>A <strong>Elumini</strong> oferece ao Usuário diversas opções do que fazer com seus Dados Pessoais coletados, tratados e armazenados, incluindo sua exclusão e/ou correção. O Usuário pode:<br/> </p> <ol> <li><strong>Excluir dados:</strong> o Usuário pode solicitar a exclusão de alguns dos seus Dados Pessoais (por exemplo, se eles não são mais necessários para lhe fornecer os serviços).</li> <li><strong>Alterar ou corrigir dados:</strong> o Usuário pode editar ou solicitar a edição de alguns dos seus Dados Pessoais. O Usuário também pode solicitar atualizações, alterações ou correções de seus dados em determinados casos, principalmente se eles estiverem incorretos.</li> <li><strong>Colocar objeções, limites ou restrições ao uso de dados:</strong> o Usuário pode solicitar a interrupção do uso de todos ou alguns de seus Dados Pessoais (por exemplo, se não tivermos o direito de continuar a usá-los), ou limitar a nossa utilização de tais dados (por exemplo, se seus Dados Pessoais estiverem incorretos ou armazenados ilegalmente), destacando-se que a Elumini poderá tratar os Dados Pessoais de acordo com as bases legais listadas neste documento.</li> <li><strong>O Usuário tem direito de acessar ou levar seus dados:</strong> o Usuário pode solicitar uma cópia dos seus Dados Pessoais e dos dados que o Usuário forneceu em um formato legível sob a forma impressa ou por meio eletrônico.</li> </ol> <br/> <p>O Usuário pode fazer as solicitações listadas acima entrando em contato com o nosso <i>Data Protection Officer</i> por meio do e-mail <u>dpo@elumini.com.br</u> e estes pedidos serão considerados de acordo com as leis aplicáveis.</p> <p></p>
                              </li>

                              <li>
                              <h5>REVISŌES À POLÍTICA</h5>
                              <p>Caso a <strong>Elumini</strong> modifique esta Política de Privacidade, tais alterações serão publicadas de forma visível no site da <strong>Elumini</strong>. Esta Política é válida a partir de 17/01/2023. Caso o Usuário tenha quaisquer questões a respeito das políticas de privacidade do website, por favor, entre em contato com a <strong>Elumini</strong>, por meio dos endereços abaixo/canal de atendimento do <i>Data Protection Officer</i>.</p>
                              </li>

                              <li>
                              <h5>TRANSFERÊNCIA INTERNACIONAL</h5>
                              <p>Atualmente, utilizamos a cloud da AWS (<i>Amazon Web Services</i>), localizada nos Estados Unidos da América (EUA).<br/><br/> Dessa forma, os dados inseridos pelos usuários em nossa Plataforma serão lá armazenados, ocorrendo, assim, a transferência internacional, nos termos da LGPD.<br/><br/> Neste contexto, adotaremos todas as medidas aplicáveis (técnicas, organizacionais e jurídicas) para garantir a conformidade e segurança dos dados armazenados, estando à disposição para sanar qualquer dúvida através de nosso DPO (<u>dpo@elumini.com.br</u>).<br/><br/> Importante também salientar que os dados pessoais fornecidos pelo usuário também sofrer a transferência internacional em virtude das empresas que compartilhamos os dados para prestação de serviços, conforme indicado no tópico “COLETA E USOS DE INFORMAÇŌES PESSOAIS”. </p>
                              </li>

                              <li>
                              <h5>ENTRE EM CONTATO</h5>
                              <p>O Usuário pode entrar em contato com o DPO através do e-mail <u>dpo@elumini.com.br</u>.</p>
                              </li>

                              </ul>
                          </div>
                        </ModalBody>
                        <form>
                          <ModalFooter>
                            <button
                              type="submit"
                              className="btn-enviar w-100 mt-2 button-entrar"
                              onClick={(event) => this.handleSubmit(event)}
                            >
                            {!this.state.loadingSubmit && t("Aceitar a Política e Cadastrar")}
                            {this.state.loadingSubmit && (
                              <Dots
                                key="dots-loading"
                                color={zdColorSecondaryOrange400}
                                size="32px"
                              />
                            )}
                            </button>
                            <button
                              className="btn-enviar w-100 mt-2 button-entrar"
                              onClick={() => this.props.history.push('/')}
                            >
                              Rejeitar a Política
                            </button>
                            <p className="text-center u-fs-md u-fg-grey-500 mt-2 mx-2">
                              {t("Ao clicar em Aceitar e cadastrar, você aceita os ")}
                              <a
                                href={TERMS_OF_USE_ROUTE}
                                className="u-semibold u-fg-grey-500"
                              >
                                {t("Termos de Uso do Enter.")}
                              </a>
                            </p>
                          </ModalFooter>
                        </form>
                      </Modal>
                        )} */}
                  </form>
                </div>
              </div>
              <div
                className="position-absolute text-light"
                style={{ width: "480px" }}
              >
                <p className="text-center u-fs-md mt-3 mb-0 px-5">
                  {t("Somos muito cuidadosos com seus dados.")}
                </p>
                <p className="text-center u-fs-md mt-0 px-5">
                  {t("Veja nossa ")}
                  <a href={TERMS_OF_USE_ROUTE} className="u-semibold">
                    {t("Política de Privacidade")}
                  </a>
                </p>
              </div>
            </div>
          </div>

          {/* <pre>{JSON.stringify(this.state, null, 2)}</pre> */}
        </div>
      );
    } else {
      return (
        <>
          <HeaderMobile />
          <div className="login-body bg-enter p-4 d-flex justify-content-between flex-column">
            <div className="container">
              <h1 className="login-title mt-0 text-light">
                {t("Cadastre-se")}
              </h1>
              <form className="login-body" onSubmit={(event) => this.handleSubmit(event)}>
                <Field className="mt-3">
                  <Label style={{ width: "100%"}}>
                    <GooglePlacesAutocomplete
                      apiKey="AIzaSyC5_B8f8Ug5dmvdYe3QWv6N2YoKszO0gK4"
                      minLengthAutocomplete={3}
                      selectProps={{
                        value: this.state.user.address,
                        onChange: this.includeLocation,
                        placeholder: t("Local de residência"),
                        noOptionsMessage: () => t("Digite as 3 primeiras letras da sua cidade"),
                        styles: {
                          singleValue: (provided: any) => ({
                            ...provided,
                            fontSize: "14px",
                          }),
                        },
                      }}
                    />
                  </Label>
                  {!this.state.locationValid && (
                    <Message validation="error">{t("Local inválido.")}</Message>
                  )}
                </Field>
                <Field className="mt-3">
                  <Input
                    disabled={this.state.loadingSubmit}
                    validation={this.state.locationValid ? undefined : "error"}
                    onBlur={this.handleInputChange}
                    name="contato"
                    placeholder={t("Telefone principal")}
                  ></Input>
                  {!this.state.contatoValid && (
                    <Message validation="error">
                      {t("Telefone inválido.")}
                    </Message>
                  )}
                </Field>

                <Field>
                  <Label className="mt-4 text-light">{t("Upload do Currículo")}</Label>
                  {this.state.policyString.length > 0 && (
                    <ReactFilestack
                      apikey={REACT_APP_FILESTACK_API}
                      componentDisplayMode={{
                        type: "button",
                        customText: "Arquivos PDF ou DOCX de até 5MB",
                        customClass: "c-txt__input",
                      }}
                      onSuccess={this.onFiles}
                      actionOptions={{
                        accept: [".pdf", ".docx"]
                      }}
                      clientOptions={{
                        security: {
                          policy: this.state.policyString,
                          signature: this.state.signatureString,
                        }
                      }}
                    />
                  )}
                  <small className="c-txt__message c-txt__message--success">
                    {this.state.user.fileName}
                  </small>
                </Field>

                <button
                  type="submit"
                  disabled={!this.state.formValid || this.state.loadingSubmit}
                  className="btn-enviar w-100 mt-4"
                >
                  {!this.state.loadingSubmit && t("Aceitar e cadastrar")}
                  {this.state.loadingSubmit && (
                    <Dots
                      key="dots-loading"
                      color={zdColorSecondaryOrange400}
                      size="32px"
                    />
                  )}
                </button>
                <p className="text-center u-fs-md mt-2 mx-2 text-light">
                  {t("Ao clicar em Aceitar e cadastrar, você aceita os ")}
                  <a href={TERMS_OF_USE_ROUTE} className="u-semibold">
                    {t("Termos de Uso do Enter.")}
                  </a>
                </p>
              </form>
            </div>
            <div className="text-light">
              <p className="text-center u-fs-md mb-0 px-2">
                {t("Somos muito cuidadosos com seus dados.")}
              </p>
              <p className="text-center u-fs-md mt-0 px-5">
                {t("Veja nossa ")}
                <a href={TERMS_OF_USE_ROUTE} className="u-semibold">
                  {t("Política de Privacidade")}
                </a>
              </p>
            </div>
          </div>
          {/* <pre>{JSON.stringify(this.state, null, 2)}</pre> */}
        </>
      );
    }
  }
}

const mapStateToProps = (store: {
  changeLanguageReducer: { currentLanguage: string };
}) => ({
  currentLanguage: store.changeLanguageReducer.currentLanguage,
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators(
    {
      currentLanguageChanged,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SignupLocation));
